import { styled } from '../theme';
import Text from './Text';

const H2 = styled(Text.withComponent('h2'))(({ theme }) => ({
    ...theme.typography.textStyles.header2,
    margin: 0,
}));

export default H2;
